import {
    List,
    Datagrid,
    TextField,
    Filter,
    TextInput,
    DateField,
    ArrayField,
    SingleFieldList,
    FunctionField,
    ChipField
  } from "react-admin";
  import CustomActions from "../../../components/CustomActions";
  import { ListPagination } from "../../../utils";
  import { exporter } from "../utils";

  const textStyle = { margin: '15px 0 0 10px' }

  const OptOutFilter = (props) => (
    <Filter {...props}>
      <TextInput label="CPF" source="user.cpf" alwaysOn />
    </Filter>
  );
  
  const OptOutList = (props) => (
    <List
      bulkActionButtons={<div />}
      perPage={25}
      title="Recusado"
      exporter={exporter}
      filters={<OptOutFilter />}
      sort={{ field: "createdAt", order: "DESC" }}
      pagination={<ListPagination />}
      actions={<CustomActions />}
      {...props}
    >
      <Datagrid rowClick="edit">
        <TextField sortable={false} label="Nome" source="name" />
        <TextField sortable={false} label="Tipo de Documento" source="typeUser.name" />
        <TextField sortable={false} label="Documento" source="document" />
        <TextField sortable={false} label="CPF" source="cpf" />
        <DateField label="Adicionado em" source="createdAt" />
        <TextField sortable={false} label="Motivo" source="name" />
        <ArrayField sortable={false} label="Laboratórios" source="labs">
          <SingleFieldList>
            <ChipField source="name" />
          </SingleFieldList>
          <FunctionField
            render={(record) => record.labsLength > 2 && <h5 style={textStyle}>+{record.labsLength - 2} Laboratórios</h5>}
          />
        </ArrayField>  
       </Datagrid>
    </List>
  );
  
  export default OptOutList;
  